import React, { memo } from "react";
import { HStack, Text, Highlight } from "@chakra-ui/react";
import colors from "app/colors";
import { getTagMention } from "modules/utils/Functions";

interface IProps {
  tag?: { displayName: string; active: boolean };
  search: string;
}

const TagOptionLabel = ({ tag, search }: IProps) => {
  if (!tag) return null;
  if (tag.active) {
    return (
      <HStack color={colors.blue} spacing={1}>
        <Text noOfLines={1} fontSize={14}>
          <Highlight
            query={search}
            styles={{
              fontWeight: 700,
              color: colors.blue,
              margin: "0 !important",
            }}
          >
            {getTagMention(tag)}
          </Highlight>
        </Text>
      </HStack>
    );
  }
  return (
    <HStack color={colors.grayMain} fontStyle="italic" spacing={1}>
      <Text noOfLines={1} fontSize={14}>
        <Highlight
          query={search}
          styles={{
            fontWeight: 700,
            color: colors.gray80,
            margin: "0 !important",
          }}
        >
          {getTagMention(tag)}
        </Highlight>
      </Text>
    </HStack>
  );
};

export default memo(TagOptionLabel);
